module.exports = __webpack_public_path__ + "img/logo_white.ca01f48e.png";